import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from '../ui/Reveal';
import { Button } from '../ui/Button';
export function CTASection() {
  return <section className="mx-auto max-w-7xl px-6 pb-24 lg:px-10" data-id="element-17" data-mp="b700135e8zgw">
      <Reveal data-id="element-18" data-mp="b7ryclqdlbav">
        <div className="relative overflow-hidden rounded-3xl bg-ink px-8 py-16 text-center shadow-lift sm:px-16 lg:py-20" data-id="element-19" data-mp="b92zsewcm6yt">
          <div className="absolute -right-16 -top-16 h-56 w-56 rounded-full border border-gold/20" data-id="element-20" data-mp="3enyrvzf2ts5x" />
          <div className="absolute -bottom-24 -left-16 h-72 w-72 rounded-full border border-gold/10" data-id="element-21" data-mp="3jmjpdr2y1xqo" />
          <div className="relative" data-id="element-22" data-mp="3old6rulcq8w4">
            <span className="text-xs uppercase tracking-widest2 text-gold" data-id="element-23" data-mp="3ol3bpslg9bjk">
              Begin a conversation
            </span>
            <h2 className="mx-auto mt-6 max-w-2xl font-serif text-3xl leading-tight text-ivory-100 sm:text-4xl lg:text-5xl" data-id="element-24" data-mp="3sl56dhsrp4pc">
              Your most important hire deserves an extraordinary partner.
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-ink-400" data-id="element-25" data-mp="3cnhu7jiyzhj4">
              Whether you are shaping a board or seeking your next chapter, we would be
              honoured to help.
            </p>
            <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row" data-id="element-26" data-mp="32okcazg1um93">
              <Button to="/employers" variant="gold" size="lg" data-id="element-27" data-mp="2yo9y4zi3spj5">
                Engage our team <ArrowRightIcon className="h-4 w-4" data-id="element-28" data-mp="2todq8p6acdyb" />
              </Button>
              <Button to="/opportunities" variant="outline" size="lg" className="border-ivory-200/30 text-ivory-100 hover:bg-ivory-100 hover:text-ink" data-id="element-29" data-mp="2tqqefk2mzkjt">
                Browse opportunities
              </Button>
            </div>
          </div>
        </div>
      </Reveal>
    </section>;
}